import { OrderedMap } from 'immutable';
import type { ID, ReduxAction } from '../../types';
import { AppState } from '@reducers/rootReducer';
import { HighlightItem } from '@models/HighlightItem';

export type SharedContactHighlightsState = OrderedMap<ID, HighlightItem[]>;
const initialSharedContactHighlightsState = OrderedMap<ID, HighlightItem[]>();

export const selectSharedContactHighlights = (contactUUID: ID) => (state: AppState) =>
  state.sharedData.highlights.get(contactUUID, []);

export function sharedContactHighlightsReducer(
  state: SharedContactHighlightsState = initialSharedContactHighlightsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_SHARED_CONTACT_HIGHLIGHTS_SUCCEEDED':
      return state.set(
        payload.contactUUID,
        payload.response.map((highlight) => new HighlightItem(highlight)),
      );

    default:
      return state;
  }
}
